import styled from 'styled-components'

export const FeaturesIcon = styled.div`
  width: 18px;
  height: 18px;
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
`

export const ModalIcon = styled.div`
  width: 24px;
  height: 24px;
  font-size: 24px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`